import { PickupParticipantEditPage } from "components/shared/pickupParticipants";
import { EditInformationSection as InformationSection } from "./components/edit/informationSection";
import { EditPickupInformationSection as PickupInformationSection } from "./components/edit/pickupInformationSection";
import { EditRegistrationInformationSection as RegistrationInformationSection } from "./components/edit/registrationInformationSection";

export const EditPickupAttractionParticipant: React.FC = () => (
  <PickupParticipantEditPage
    kind="attraction"
    variant="admin"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);
